import { PlayerEnvironment } from "./player_environment";
import { Timing } from "./utils/timing";
import AhoyAdapter from "./adapters/ahoy_adapter";
import VideoJsAdapter from "./adapters/videojs_adapter";

export class PlayerAhoyLivestreamEvent {
  static env(){
    return Object.assign({
      player_name: "videojs",
      player_version: VideoJsAdapter.version(),
    },PlayerEnvironment.currentEnv());
  }

  static globalAppendData(){
    return Object.assign({}, this._globalAppendData) || {};
  }

  static appendGlobalProperties(properties){
    return Object.assign(this.globalAppendData(), properties);
  }

  static sendEvent(type, properties, prefix="LIVESTREAM::"){
    let eventProperties = this.appendGlobalProperties(properties)
    AhoyAdapter.track(prefix + type, eventProperties);
  }

  static sendStart(livestreaming_id, stream_type, hasAd, playUUID, currentTime, readyState, networkState, bufferedVideoFrames, bandwidth, quality, assetSource, codec, hdcp_support, video_source_bitrate, video_source_height, video_source_width, player_height, player_width){
    const env = this.env();
    window.playback.startTime = env.event_time;

    var properties = Object.assign({
      livestreaming_id: livestreaming_id,
      stream_type: stream_type,
      setup_time: Timing.time("vjs-setup"),
      has_ad: hasAd,
      play_uuid: playUUID,
      current_time: currentTime,
      ready_state: readyState,
      network_state: networkState,
      buffered_video_frames: bufferedVideoFrames,
      has_adblocker: PlayerEnvironment.hasAdBlocker(),
      vjs_html5: VideoJsAdapter.isHtml5Supported(),
      vjs_mpegurl: VideoJsAdapter.isMpegUrlSupported(),
      bandwidth,
      quality,
      after_retry: window.playback.restartCount > 0,
      asset_source: assetSource,
      codec: codec,
      hdcp_support: hdcp_support,
      livestream_start_time: ( window.playback.startTime || null ),
      video_source_bitrate,
      video_source_height,
      video_source_width,
      player_height,
      player_width
    }, env);


    this.sendEvent("START", properties);
    this.sendEvent("START", properties, 'PLAYBACK::');
  }

  static sendPlay(livestreaming_id, seconds, playUUID, toggle, bandwidth, quality, assetSource, network_state, has_ad, stream_type, video_source_bitrate, video_source_height, video_source_width, player_height, player_width){
    var time = { minutes: seconds/60 };
    if(toggle){
      time = { seconds: seconds };
    }

    var properties = Object.assign(
        {
          livestreaming_id: livestreaming_id,
          asset_source: assetSource
        },
        time,
        {
          play_uuid: playUUID
        },
        {
          bandwidth,
          quality,
          network_state,
          livestream_start_time: ( window.playback.startTime || null ),
          restart_count: ( window.playback.restartCount || 0 ),
          has_ad,
          stream_type,
          video_source_bitrate,
          video_source_height,
          video_source_width,
          player_height,
          player_width,
        },
        this.env());
    this.sendEvent("PLAY", properties);
  }

  static sendSetupError(livestreaming_id, message, has_ad, playUUID){
    var properties = Object.assign({
      livestreaming_id: livestreaming_id,
      message: message,
      has_ad: has_ad,
      play_uuid: playUUID,

    }, this.env());
    this.sendEvent("SETUP ERROR", properties);
  }

  static sendError(livestreaming_id, code, message, videoDuration, currentTime, playUUID, readyState, networkState, bufferedVideoFrames, assetSource){
    var properties = Object.assign({
      livestreaming_id: livestreaming_id,
      error_code: code,
      message: message,
      video_duration: videoDuration,
      current_time: currentTime,
      play_uuid: playUUID,
      ready_state: readyState,
      network_state: networkState,
      buffered_video_frames: bufferedVideoFrames,
      asset_source: assetSource,

      vjs_html5: VideoJsAdapter.isHtml5Supported(),
      vjs_mpegurl: VideoJsAdapter.isMpegUrlSupported(),
    }, this.env());

    this.sendEvent("ERROR", properties);
  }

  static sendMeta(livestreaming_id, level, levels, targetBitrate, playUUID){
    var properties = Object.assign({
      livestreaming_id: livestreaming_id,
      level: level,
      levels: levels,
      target_bitrate: targetBitrate,
      play_uuid: playUUID,

    }, this.env());
    this.sendEvent("META", properties);
  }

  static sendBuffer(livestreaming_id, seconds, playUUID, timer, streamType, bandwidth, quality, assetSource, video_source_bitrate, video_source_height, video_source_width, player_height, player_width){
    var properties = Object.assign({
      livestreaming_id: livestreaming_id,
      seconds: seconds,
      play_uuid: playUUID,
      timer: timer,
      streamType: streamType,
      bandwidth,
      quality,
      asset_source: assetSource,
      video_source_bitrate,
      video_source_height,
      video_source_width,
      player_height,
      player_width
    }, this.env());
    this.sendEvent("BUFFER", properties);
  }

  static sendAdsRequest(play_uuid, ad_uuid, ad_tag, videopremier, livestreaming_id) {
    var properties = Object.assign({
      play_uuid: play_uuid,
      ad_uuid: ad_uuid,
      ad_tag: ad_tag,
      videopremier: videopremier,
      livestreaming_id: livestreaming_id
    }, this.env());

    this.sendEvent("AD::REQUEST", properties);
  }

  static sendAdWatch(livestreaming_id, duration, currentTime, playUUID, adUUID){
    var properties = Object.assign({
      livestreaming_id : livestreaming_id,
      duration         : duration,
      seconds         : currentTime,
      play_uuid        : playUUID,
      ad_uuid          : adUUID
    }, this.env());

    this.sendEvent("AD::WATCH", properties);
  }

  static sendGeneralSeek(content_id, content_type, position, offset, play_uuid, action) {
    const props = Object.assign({
      content_id,
      content_type,
      position,
      offset,
      play_uuid,
      action
    }, this.env());

    this.sendEvent('SEEK', props, 'PLAYBACK::');
  }
}
